import Details from "./Details";
import Title from "./Title";

const Container = ({ children }) => {
  return (
    <section className="w-full px-8">
      <Title />
      <Details />
      <article>{children}</article>
    </section>
  );
};

export default Container;
